import { RefObject, useEffect, useRef, useState } from 'react';

import clsx from 'clsx';

import LoaderIcon from '@/components/LoaderIcon';

type MapProps = {
  lat: number;
  lon: number;
};

const Map = ({ lat, lon }: MapProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const frameElement: RefObject<HTMLIFrameElement> = useRef(null);

  // Иногда isLoad не стреляет, но iframe загрузился. Отлавливаем этот момент отдельно.
  useEffect(() => {
    setTimeout(() => {
      if (frameElement.current?.contentWindow) {
        setIsLoading(false);
      }
    }, 1000);
  });

  return (
    <div className="relative px-4 aspect-video lg:px-0">
      {isLoading && (
        <div role="status" className="absolute inset-0 z-10 flex h-full w-full bg-white">
          <LoaderIcon width="300" height="300" viewBox="0 0 300 300" />
        </div>
      )}
      <iframe
        title="Weather Map"
        className={clsx('absolute inset-0', isLoading && 'p-0.5')}
        src={`https://embed.windy.com/embed2.html?lat=${lat}&lon=${lon}&zoom=6&level=surface&overlay=rain&menu=&message=true&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=&detailLat=47.267&detailLon=11.400&metricWind=m%2Fs&metricTemp=%C2%B0C`}
        frameBorder="0"
        height="100%"
        width="100%"
        ref={frameElement}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};

export default Map;
